import { customInstance } from "../../custom-instance";
export const get = () => {
    /**
     * @summary 현재 로그인한 사용자의 그룹 포함 상세 정보를 조회한다.
     */
    const authControllerGetLoginUserData = () => {
        return customInstance({
            url: `/auth/user`,
            method: "GET",
        });
    };
    /**
     * @summary Cognito 사용자 풀의 전체 사용자 목록을 조회한다.
     */
    const authControllerListUsers = () => {
        return customInstance({
            url: `/auth/users`,
            method: "GET",
        });
    };
    /**
     * @summary Basic 인증 헤더로 Cognito 로그인을 수행하고 토큰을 발급한다.
     */
    const authControllerLoginWithCognito = () => {
        return customInstance({
            url: `/auth/login`,
            method: "POST",
        });
    };
    /**
     * @summary Refresh 토큰으로 새로운 Access 토큰을 재발급한다.
     */
    const authControllerGetAccesTokenFromRefreshToken = () => {
        return customInstance({
            url: `/auth/access/reissue`,
            method: "GET",
        });
    };
    /**
     * @summary 현재 세션을 로그아웃하고 Refresh 토큰을 철회한다.
     */
    const authControllerLogout = () => {
        return customInstance({ url: `/auth/logout`, method: "DELETE" });
    };
    /**
     * @summary 기존 비밀번호를 사용하여 새 비밀번호로 변경한다.
     */
    const authControllerChangePassword = (changePasswordDto) => {
        return customInstance({
            url: `/auth/password/change`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: changePasswordDto,
        });
    };
    /**
     * @summary 비밀번호 재설정 인증 코드를 이메일로 요청한다.
     */
    const authControllerForgotPasswordRequest = (forgotPasswordRequestDto) => {
        return customInstance({
            url: `/auth/password/forgot/request`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: forgotPasswordRequestDto,
        });
    };
    /**
     * @summary 인증 코드를 확인하고 새 비밀번호를 설정한다.
     */
    const authControllerForgotPasswordConfirm = (forgotPasswordConfirmDto) => {
        return customInstance({
            url: `/auth/password/forgot/confirm`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: forgotPasswordConfirmDto,
        });
    };
    /**
     * @summary 만료된 임시 비밀번호를 재발송한다. (FORCE_CHANGE_PASSWORD 상태 사용자 전용)
     */
    const authControllerResendInvitation = (resendInvitationDto) => {
        return customInstance({
            url: `/auth/resend-invitation`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: resendInvitationDto,
        });
    };
    /**
     * @summary 임시 비밀번호(NEW_PASSWORD_REQUIRED) 상태에서 새 비밀번호를 설정한다.
     */
    const authControllerCompleteNewPassword = (newPasswordRequiredDto) => {
        return customInstance({
            url: `/auth/password/new-required`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: newPasswordRequiredDto,
        });
    };
    return {
        authControllerGetLoginUserData,
        authControllerListUsers,
        authControllerLoginWithCognito,
        authControllerGetAccesTokenFromRefreshToken,
        authControllerLogout,
        authControllerChangePassword,
        authControllerForgotPasswordRequest,
        authControllerForgotPasswordConfirm,
        authControllerResendInvitation,
        authControllerCompleteNewPassword,
    };
};
